import ApplicationLayout from '@rio-cloud/rio-uikit/ApplicationLayout';
import Button from '@rio-cloud/rio-uikit/Button';
import NotBookedState from '@rio-cloud/rio-uikit/NotBookedState';
import { FormattedMessage } from 'react-intl';

const NotBookedStatePage = () => {
    const featureList = [
        <FormattedMessage key='feature1' id='general.notBooked.feature1' />,
        <FormattedMessage key='feature2' id='general.notBooked.feature2' />,
        <FormattedMessage key='feature3' id='general.notBooked.feature3' />,
        <FormattedMessage key='feature4' id='general.notBooked.feature4' />,
    ];
    return (
        <ApplicationLayout.Body>
            <NotBookedState
                headline={<FormattedMessage id='general.notBooked.heading' />}
                icons={[
                    {
                        name: 'icon-stars',
                        color: 'text-color-highlight',
                    },
                ]}
                message={<FormattedMessage id='general.notBooked.message' values={{ b: chunk => <b>{chunk}</b> }} />}
                features={featureList}
            >
                <div className='display-flex justify-content-center align-items-center gap-20'>
                    <Button
                        onClick={() => (window.location.href = 'https://rio.cloud/en/marketplace/man-digital-services')}
                    >
                        <FormattedMessage id='general.notBooked.secondaryButton' />
                    </Button>
                    <Button
                        bsStyle={Button.PRIMARY}
                        onClick={() =>
                            (window.location.href =
                                'https://rio.cloud/en/marketplace/produkt/man-charge-and-go#c139910')
                        }
                    >
                        <FormattedMessage id='general.notBooked.primaryButton' />
                    </Button>
                </div>
            </NotBookedState>
        </ApplicationLayout.Body>
    );
};

export default NotBookedStatePage;
